<template>
  <div class="root">
    <div class="action-top">
      <div class="action-list">
        <div class="action-list-item" @click="$router.push({name:'rechargeCheck',query:{iccid:iccid,short_number:packageInfo.short_number,simAuthStatusName,simStatusName,end:packageInfo.end,settlementDate:packageInfo.settlementDate}})">
          <img src="static/images/action-1_03.png">
          <span>充值交费</span>
        </div>
        <div class="action-list-item" @click="$router.push({name:'feedback',query:{iccid:iccid}})">
          <img src="static/images/action-2_03.png">
          <span>投诉建议</span>
        </div>
        <div v-if="packageInfo.kind==3 || packageInfo.kind==4" class="action-list-item" @click="$router.push({name:'cardBalance',query:{iccid:iccid}})">
          <img src="static/images/action-3_09.png">
          <span>我的积分</span>
        </div>
        <div class="action-list-item" @click="checkCard" >
          <img src="static/images/action-4_06.png">
          <span>智能检测</span>
        </div>
        <div v-if="packageInfo.kind != 3" class="action-list-item" @click="$router.push({name:'bind',query:{nostorage:1}})">
          <van-icon size=".30rem" class="icon" color="#4bd5d3"  name="exchange" />
          <span>切换号码</span>
        </div>
      </div>
      <div class="action-list">
        <div v-if="packageInfo.kind == 3" class="action-list-item" @click="$router.push({name:'bind',query:{nostorage:1}})">
          <van-icon size=".30rem" class="icon" color="#4bd5d3"  name="exchange" />
          <span>切换号码</span>
        </div>
        <div class="action-list-item" @click="cardModal=true">
          <van-icon size=".30rem" class="icon" color="#4bd5d3"  name="todo-list" />
          <span>历史查询</span>
        </div>
        <div class="action-list-item" @click="qrcode=true">
          <van-icon size=".30rem" class="icon" color="#4bd5d3"  name="qr" />
          <span>二维码</span>
        </div>
        <div class="action-list-item" v-if="packageInfo.kind != 3"></div>
        <div class="action-list-item"></div>
      </div>
    </div>
    <fieldset class="md-field card-info" v-if="operator.system=='SHUANGKAONE'"><!---->
      <div class="device-box">
        <div class="title">
          <span>信号强度:
            <span v-if="deviceInfo.rsrp<=50 || deviceInfo.rsrp == undefined">强</span>
            <span v-else-if="deviceInfo.rsrp<=70">良</span>
            <span v-else-if="deviceInfo.rsrp<=90">一般</span>
            <span v-else>差</span>
          </span>
          <div class="wifi-btn">
            <span @click="resetDevice">恢复出厂</span>
            <span @click="saveSsid" v-if="showSaveSsid==true">应用WiFi修改</span>
          </div>
        </div>
        <div class="wifi-box">
          <div class="md-field-item-content">
            <label class="md-field-item-title">WiFi名称</label>
            <div class="md-field-item-control">
              <input :placeholder="deviceInfo.ssid" v-model="editSsid.ssid">
            </div>
          </div>
          <div class="md-field-item-content">
            <label class="md-field-item-title">WiFi密码</label>
            <div class="md-field-item-control">
              <input :placeholder="deviceInfo.key" v-model="editSsid.key">
            </div>
          </div>
        </div>
      </div>
    </fieldset>
    <div class="card-info">
      <div class="iccid-info">
        <div class="text-left">充值号：
          <span class="number" v-if="packageInfo.short_number">{{packageInfo.short_number}}</span>
          <span class="number" v-else>{{iccid}}</span>
        </div>
        <div v-if="packageInfo.short_number" class="change-card" v-clipboard:copy="packageInfo.short_number" v-clipboard:success="onCopySuccess"
             v-clipboard:error="onCopyError">
          <van-icon size=".24rem" class="icon" color="#fff"  name="edit" />复制
        </div>
        <div v-else class="change-card" v-clipboard:copy="iccid" v-clipboard:success="onCopySuccess"
             v-clipboard:error="onCopyError">
          <van-icon size=".24rem" class="icon" color="#fff"  name="edit" />复制
        </div>
      </div>
      <template v-if="operator.system">
        <div class="card-status-list" v-if="operator.system!='SHUANGKAONE'">
          <div class="card-status-list-item">
            <div class="text-1 color-blue">{{totalUsage}}G</div>
            <div class="text-2">本月套餐</div>
          </div>
          <div class="card-status-list-item">
            <div class="text-1" v-if="simAuthStatusName == '请先充值'" @click="$router.push({name:'rechargeCheck',query:{iccid:iccid,short_number:packageInfo.short_number,simAuthStatusName,simStatusName,end:packageInfo.end}})">{{simAuthStatusName}}</div>
            <div class="text-1" v-else>{{simAuthStatusName}}</div>
            <div @click="showCopy=true" class="text-2" v-if="simAuthStatusName=='未实名'">点击实名</div>
            <div class="text-2" v-else>实名状态</div>
          </div>
          <div class="card-status-list-item">
            <div class="text-1">{{simStatusName}}</div>
            <div class="text-2">激活状态</div>
          </div>
          <div class="card-status-list-item">
            <div class="text-1 color-blue">{{packageInfo.nextAmount}}G</div>
            <div class="text-2">次月套餐</div>
          </div>
        </div>
        <fieldset class="md-field" v-else style="margin-top: -.4rem"><!---->
          <div class="md-field-item-content" v-if="item.using>0" v-for="(item,type) in shuangka" :key="type" style="display: block;padding: .14rem 0;">
            <div class="md-field-item-content" style="border: none;">
              <label class="md-field-item-title" style="width: 4rem;white-space: nowrap;">{{operatorType[type]}}（<span style="color:#00a720;">当前使用</span>）</label>
             <!-- <div class="md-field-item-control">
                {{item.iccid}}
              </div>-->
              <div class="md-field-item-right" @click="qieka(type,item.simIndex)">
                切换<van-icon name="arrow"></van-icon>
              </div>
            </div>
            <!--<div class="btns md-field-item-content" style="border: none;min-height: .5rem;margin-top: .2rem">
              <div class="shuangka-status">
                <span v-if="item.statusName" :class="item.statusName=='在用' || item.statusName=='已激活' || item.statusName=='正常' ? 'success':'error'">{{item.statusName}}</span>
                <span :class="{success:item.auth==1,error:item.auth==0}">{{item.auth==1?'已实名':'未实名'}}</span>
              </div>
              <div class="shuangka-btns">
              <span v-clipboard:copy="item.iccid" v-clipboard:success="onCopySuccess"
                    v-clipboard:error="onCopyError">复制号码</span>
                <a :href="item.authUrl" v-if="item.auth==0 || !item.auth">去实名</a>
              </div>
            </div>-->

            <div class="card-status-list" v-if="item.using>0">
              <div class="card-status-list-item">
                <div class="text-1 color-blue">{{totalUsage}}G</div>
                <div class="text-2">本月套餐</div>
              </div>
              <div class="card-status-list-item">
                <div class="text-1" v-if="simAuthStatusName == '请先充值'" @click="$router.push({name:'rechargeCheck',query:{iccid:iccid,short_number:packageInfo.short_number,simAuthStatusName,simStatusName,end:packageInfo.end}})">{{simAuthStatusName}}</div>
                <div class="text-1" v-else>{{simAuthStatusName}}</div>
                <div @click="authIccid=item.iccid;operator.authUrl=item.authUrl;showCopy=true" class="text-2" v-if="simAuthStatusName=='未实名'">点击实名</div>
                <div class="text-2" v-else>实名状态</div>
              </div>
              <div class="card-status-list-item">
                <div class="text-1">{{item.statusName}}</div>
                <div class="text-2">激活状态</div>
              </div>
              <div class="card-status-list-item">
                <div class="text-1 color-blue">{{packageInfo.nextAmount}}G</div>
                <div class="text-2">次月套餐</div>
              </div>
            </div>

          </div>
        </fieldset>
      </template>
    </div>
    <div class="package-list">
      <div class="title">
        <div>套餐详情 <a @click="refresh">刷新</a></div>
        <div>当前月结日:每月{{packageInfo.settlementDate}}号</div>
      </div>
      <div class="now-package-expire">
        <div>
          <div class="text-1">周期：{{packageInfo.start}}～{{packageInfo.end}}</div>
          <div class="text-2" @click="$router.push({name:'rechargeCheck',query:{iccid:iccid,short_number:packageInfo.short_number,simAuthStatusName,simStatusName,end:packageInfo.end}})">{{packageInfo.expire == '已过期' || remainUsage  == 0 ? '需充值' :''}}</div>
        </div>
      </div>
      <div class="now-package-item">
        <div class="package-name">
          <div>流量套餐（{{totalUsage}}G）</div>
          <div>已使用{{usedUsage}}G</div>
        </div>
        <div class="package-bili">
          <div class="bar" :style="{width:( totalUsage>0 ? (usedUsage/totalUsage*100) : 0)+'%'}"></div>
        </div>
      </div>
    </div>
    <div class="bottom-bts-2">
      <a v-if="customerUrl" :href="customerUrl" class="btn-item">
        联系客服
      </a>
      <a v-if="operator.deviceUrl" :href="operator.deviceUrl" class="btn-item">
        设备管理
      </a>
      <a v-if="operator.imeiBind==1 && rebind == true" @click="resetImei" class="btn-item">
        自助复机
      </a>
      <a v-else-if="helpUrl" :href="helpUrl" class="btn-item">
        使用帮助
      </a>
    </div>
    <div  class="bottom-tips">
      <div  class="title">温馨提示：</div>
      <ol>
        <li>根据工信部《入网用户真实身份信息登记规定》</li>
        <li>1.您当前使用的产品需实名认证注册后可正常使用;</li>
        <li>2.任何机构或个人不可代他人进行实名认证操作;</li>
        <li>3.所有用户实名认证信息需保证真实有效。</li>
        <li>若您在实名或使用中遇到任何问题，可随时与客服联系!</li>
      </ol>
    </div>

    <van-dialog
      v-model="showNowPackage"
      title="温馨提示"
      show-cancel-button
      confirmButtonText="确认"
      @confirm="$router.push({name:'recharge',query:{iccid:iccid,type:0,short_number:packageInfo.short_number}})"
    >
      <div style="padding: .2rem;text-align: center;" >
        <span style="color: #0051fe">{{packageInfo.short_number?packageInfo.short_number:iccid}}</span>当前无可用套餐 是否立即办理本月套餐使用，点击确认进行办理
      </div>
    </van-dialog>
    <van-dialog
      v-model="showNextPackage"
      title="温馨提示"
      show-cancel-button
      confirmButtonText="确认"
      @confirm="$router.push({name:'recharge',query:{iccid:iccid,type:1,short_number:packageInfo.short_number}})"
    >
      <div style="padding: .2rem;text-align: center;" >
        <span style="color: #0051fe">{{packageInfo.short_number?packageInfo.short_number:iccid}}</span>当前套餐剩余<stong>{{packageInfo.leftDays}}</stong>天到期 是否提前办理次月套餐 点击确认进行办理
      </div>
    </van-dialog>

    <van-dialog
      v-model="showCopy"
      title="实名提示"
      show-cancel-button
      confirmButtonText="去实名"
      v-if="operator.authUrl && operator.authUrl.indexOf('realname') !== -1"
      @confirm="handleCopyIccid"
    >
      <div style="padding: .2rem 0;text-align: center;" >
        点击“去实名”，开始实名
      </div>
    </van-dialog>
    <van-dialog
      v-model="showCopy"
      title="点击去实名， 打开联通官方实名小程序"
      :show-confirm-button="false"
      close-on-click-overlay
      v-else-if="operator.authUrl && operator.authUrl.indexOf('10646') !== -1"
    >
      <div style="padding: .2rem 0 .2rem 0;text-align: center;" >
        <div style="color: #1e88e5;border-top: 1px solid #cdcbcb;text-align: center;padding: 4px 0;">
          <wx-open-launch-weapp
            id="launch-btn"
            appid="wxa5b3db0cd2c5a1ed"
            :path="'pages/login/index?iccid='+(authIccid?authIccid:iccid)" >
            <script  type="text/wxtag-template">
              <style>.btn {color: #1e88e5;font-size: 20px; padding-top: 10px;width: 100%;}</style>
              <div class="btn">去实名</div>
            </script>
          </wx-open-launch-weapp>
        </div>
      </div>
    </van-dialog>
    <van-dialog
      v-model="showCopy"
      title="实名提示"
      show-cancel-button
      confirmButtonText="已复制，去实名"
      v-else-if="operator.authUrl"
      @confirm="handleCopyIccid"
    >
      <div style="padding: .2rem 0;text-align: center;" >
        <div>请先复制卡号后，完成官方实名</div>
        <div>{{authIccid?authIccid:iccid}} <a style="color: #ee0a24" v-clipboard:copy="authIccid?authIccid:iccid" v-clipboard:success="onCopySuccess"
                                              v-clipboard:error="onCopyError"><svg style="color: #1e88e5" v t="1622559508450" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3548" width="16" height="16"><path style="color: #1e88e5" v d="M720 192h-544A80.096 80.096 0 0 0 96 272v608C96 924.128 131.904 960 176 960h544c44.128 0 80-35.872 80-80v-608C800 227.904 764.128 192 720 192z m16 688c0 8.8-7.2 16-16 16h-544a16 16 0 0 1-16-16v-608a16 16 0 0 1 16-16h544a16 16 0 0 1 16 16v608z" p-id="3549"></path><path d="M848 64h-544a32 32 0 0 0 0 64h544a16 16 0 0 1 16 16v608a32 32 0 1 0 64 0v-608C928 99.904 892.128 64 848 64z" p-id="3550"></path><path d="M608 360H288a32 32 0 0 0 0 64h320a32 32 0 1 0 0-64zM608 520H288a32 32 0 1 0 0 64h320a32 32 0 1 0 0-64zM480 678.656H288a32 32 0 1 0 0 64h192a32 32 0 1 0 0-64z" p-id="3551"></path></svg>点击复制</a></div>
      </div>
    </van-dialog>
    <van-action-sheet
      v-model="cardModal"
      cancel-text="取消"
    >
      <div class="content" style="padding: .4rem 0;">
        <div style="font-size: .36rem;line-height: .8rem;text-align: center;color: #333333;" v-for="(item,index) in cardlist" :key="index"><span @click="handleChooseCard(item.value)">{{item.value}}</span> <van-icon @click.prevent="del(item.value)" color="#db2020" name="delete" /></div>
      </div>
    </van-action-sheet>
    <van-dialog v-model="showQRcodeModal" :showConfirmButton="false" title="长按关注官方公众号">

      <img :src="qrcodeurl" style="display: block;width: 100%;"/>
    </van-dialog>

    <van-dialog v-model="qrcode" title="长按保存二维码">
      <img :src="rechargeQr" style="display: block;width: 100%;"/>
    </van-dialog>
  </div>
</template>
<script>
  import wx from "weixin-js-sdk";
    import Vue from "vue";
    import VueClipboard from 'vue-clipboard2'
    Vue.use(VueClipboard)
    export default {
        name: "App",
        data: () => ({
          showNowPackage:false,
          showNextPackage:false,
            token: '',
          qrcode:false,
          authIccid:"",
          showCopy:false,
            memberInfo: {},
            iccid:'',
            cardlist:[],
            operator:{},
            showNotice:false,
            showQRcodeModal:false,
            showContent:false,
            qrcodeurl:'',
 	          customerUrl:'',
            cardModal:false,
            currentNet:0,
            netType:{
                0:'电信网络',
                1:'移动网络',
                2:'联通网络'
            },
            totalUsage:0,
            remainUsage:0,
            simStatusName: '未知状态',
            simAuthStatus: 0,
            unbindNeedImei: 0,
            rebind:0,
            change:0,
            usedUsage:0,
            packageInfo:{
              short_number:''
            },
            helpUrl:'',
            deviceInfo:{},
            editSsid:{ssid:'',key:''},
            shuangka: {
                liantong: {},
                dianxin: {}
            },
            operatorType:{
                liantong:"中国联通",
                dianxin:'中国电信'
            },
        }),
        computed:{
            showSaveSsid(){
                if(this.editSsid.ssid.length>0 || this.editSsid.key.length>0){
                    return true
                }
                return false
            },
            simAuthStatusName() {
                if(this.operator.activeRule==2 && this.simAuthStatus == 0 && this.totalUsage == 0){
                    //先充值后实名
                    return '请先充值';
                }else{
                    return this.simAuthStatus == 1 ? '已实名' : '未实名'
                }
            },
          rechargeQr(){
            let domain = process.env.DOMAIN_ENV+'/base/qrcode?iccid='+this.iccid
            return domain
          }
        },
        watch: {
            iccid(value) {
                this.subscribeStatus()
                this.queryOperatorInfo();
                //this.queryCardStatus();
                this.queryPackageInfo()
              this.queCardInfo();
            }
        },
      mounted() {
        this.initWechatJs()
      },
      created() {

            this.currentNet = localStorage.getItem('nettype')
            if(this.$route.query.appid && this.$route.query.appid > 0){
                sessionStorage.setItem('appid',this.$route.query.appid)
            }
            this.fetchData('/member/info', {}, (res) => {
                if (res.code) {
                    this.memberInfo = res.data
                    if(this.memberInfo.subscribe == 0){
                        this.showNotice = true
                    }
                }
            })
            let lastIccid = localStorage.getItem('iccid')
            if(lastIccid){
                this.iccid = lastIccid
            }
            this.queryUserCards();
            this.fetchData('/config/customerUrl',{},res=>{
              if(res.data){
                this.customerUrl = res.data
              }
            })
            this.fetchData('/config/helpUrl',{},res=>{
                if(res.data){
                    this.helpUrl = res.data
                }
            })
        },
        methods: {
          queCardInfo(){
            this.fetchData('/card/queryBulu',{iccid:this.iccid},(res)=>{
              this.$toast.clear();
              if(res.code){
                this.$dialog.alert({
                  title: "提示",
                  message: res.msg,
                  confirmButtonText: '去补录',
                  showCancelButton: true
                }).then(()=>{
                    this.$router.push({name:'bulu',query:{iccid:this.iccid}})
                })
              }
            })
          },
          initWechatJs(){
            let url = encodeURIComponent(location.href.split('#')[0])
            this.fetchData('/wechat/jssdk',{url:url},(res)=>{
              if(res.code){
                wx.config(res.data);
                wx.ready(()=>{
                  this.wxReady = true;
                  wx.hideMenuItems({
                    menuList: [
                      "menuItem:share:appMessage",
                      "menuItem:share:timeline",
                      "menuItem:share:qq",
                      "menuItem:share:weiboApp",
                      "menuItem:share:facebook",
                      "menuItem:share:QZone",
                      "menuItem:copyUrl",
                      "menuItem:originPage",
                      "menuItem:openWithQQBrowser",
                      "menuItem:openWithSafari",
                      "menuItem:readMode"
                    ]
                  });
                })
              }
            })
          },
          del(iccid){
            this.$dialog.alert({
              title: "提示",
              message: "确认从列表中删除？",
              confirmButtonText: '确认',
              showCancelButton: true
            }).then(() => {
              this.fetchData('/card/del',{iccid:iccid} , res => {
                this.$toast.clear()
                if (res.code) {
                  this.queryUserCards()
                  this.$toast.success(res.msg);
                } else {
                  this.$toast.fail(res.msg);
                }
              })
            })
          },
            resetDevice(){
                this.$dialog.alert({
                    title: "提示",
                    message: "恢复出厂设置会使设备重启，并且重置WiFi名称和密码，确认恢复出厂",
                    confirmButtonText: '确认',
                    showCancelButton: true
                }).then(() => {

                    this.$toast.loading('发送中', {duration: 0});
                    this.fetchData('/card/resetDevice',{iccid:this.iccid} , res => {
                        this.$toast.clear()
                        if (res.code) {
                            this.$toast.success(res.msg);
                        } else {
                            this.$toast.fail(res.msg);
                        }
                    })

                });
            },
            saveSsid(){
                if(!this.editSsid.ssid || /^[a-zA-z\d_\-]+$/.test(this.editSsid.ssid) == false){
                    return this.$toast.fail('请输入字母数字下划线组成的WiFi名称');
                }
                if(!this.editSsid.key || /^[a-zA-z\d_\-]{8,}$/.test(this.editSsid.key) == false){
                    return this.$toast.fail('密码最低8位，支持数字字母下划线');
                }
                this.editSsid.iccid = this.iccid
                this.$toast.loading('发送中', {duration: 0});
                this.fetchData('/card/savessid', this.editSsid , res => {
                    this.$toast.clear()
                    if (res.code) {
                        this.$toast.success(res.msg);
                    } else {
                        this.$toast.fail(res.msg);
                    }
                })


            },
            qieka(type,simIndex){
                this.$dialog.alert({
                    title: "提示",
                    message: "即将切换网络信号（每月限制切网2次） 切网成功之后信号灯常绿即可正常使用 （大概2-3分钟）",
                    confirmButtonText: '立即切换',
                    showCancelButton: true
                }).then(() => {

                    this.$toast.loading('切换中', {duration: 0});
                    this.fetchData('/card/shuangkaqieka',{simIndex:simIndex,iccid:this.iccid} , res => {
                        this.$toast.clear()
                        if (res.code) {
                            this.queryCardStatus();
                            this.$toast.success(res.msg);
                        } else {
                            this.$toast.fail(res.msg);
                        }
                    })

                });
            },
          refresh(){
            //this.queryCardStatus();
            this.queryOperatorInfo();
            this.queryPackageInfo()
          },
          resetImei() {
            if(this.operator.imeiMsg) {
              this.$dialog.confirm({
                title: '注意',
                message: this.operator.imeiMsg,
              })
                .then(() => {
                  this.doReset()
                })
                .catch(() => {
                  console.log('cancel')
                });
            }else{
              this.doReset()
            }
          },
            doReset(){
                if (this.operator.needImei == 0) {
                    //不需要上报imei
                    this.$toast.loading('解绑中')
                    let url
                    if(this.operator.autoImei == 1){
                        url = '/card/active'
                    }else{
                        url = '/card/resetImei'
                    }
                    this.fetchDataPost(url, {iccid: this.iccid}, (res) => {
                        this.$toast.clear();
                        if (res.code) {
                            this.$toast.success(res.msg)
                        } else {
                            this.$toast({icon:'fail',type:'type',message:res.msg,className:'toastWidth180px'})
                        }
                    })

                } else {
                    this.inputImeiModal = true;
                }
            },
          handleCopyIccid(){
            if(this.operator.authUrl) {
              window.location.href = this.operator.authUrl
            }else{
              this.$toast.fail('未配置实名网址，请刷新或联系客服');
            }
          },
            queryPackageInfo(){
                this.fetchData("/card/cardPackageInfo",{iccid:this.iccid},res=>{
                    this.packageInfo = res.data
                  if(this.packageInfo.expire == '已过期'){
                    this.showNowPackage = true
                  }else if(this.packageInfo.leftDays<=5){
                    this.showNextPackage = true
                  }
                })
            },
            queryCardStatus() {
                this.$toast.loading({message: '加载中',duration:50000});
                this.fetchData('/card/status', {iccid: this.iccid}, (res) => {
                    this.$toast.clear()
                    if (res.code) {
                      this.simStatusName = res.data.simStatusName;
                      this.simAuthStatus = res.data.simAuthStatus;
                      this.totalUsage = res.data.total;
                      this.remainUsage = res.data.remain
                      this.usedUsage = res.data.used
                      this.expireDate = res.data.expire
                      this.rebind = res.data.rebind
                      /*if(this.operator.destroy==1){
                        this.$dialog.alert({
                          title: false,
                          message: this.operator.destroyMsg ?this.operator.destroyMsg : "卡已销号，请联系客服",
                          confirmButtonText: '确定',
                          showCancelButton:false
                        }).then(() => {

                        });
                        return ;
                      }*/
                        /*if(this.operator.exchangeSwitch==1){
                            this.$dialog.alert({
                                title: false,
                                message: this.operator.destroyMsg ?this.operator.destroyMsg : "当前卡已不支持续费，我们将为您补发资费更低的卡",
                                confirmButtonText: '立即换卡',
                                showCancelButton:true
                            }).then(() => {
                                this.changeCard(this.iccid)
                            });
                            return ;
                        }*/
                      /*if(res.data.change == 1){
                          this.change = 1
                          if(this.operator.exchangeSwitch==1){
                              this.$dialog.alert({
                                  title: false,
                                  message: this.operator.destroyMsg ?this.operator.destroyMsg : "当前卡已不支持续费，我们将为您补发资费更低的卡",
                                  confirmButtonText: '立即换卡',
                                  showCancelButton:true
                              }).then(() => {
                                  this.changeCard(this.iccid)
                              });
                              return ;
                          }
                      }else if(res.data.change==2 && res.data.id){
                          this.change = 1
                          this.$dialog.alert({
                              title: false,
                              message: "您已申请换卡，点击查看换卡进度",
                              confirmButtonText: '立即查看',
                              showCancelButton:true
                          }).then(() => {
                              this.$router.push({name:'changeInfo',query:{id:res.data.id}})
                          }).catch(()=>{});
                          return;
                      }*/

                        if(res.data.data && res.data.data.shuangka)  {
                          this.rebind = false
                            this.shuangka = res.data.data.shuangka
                            for(let i in this.shuangka){
                              if(this.shuangka[i].using>0)
                                this.fetchData('/card/status', {iccid: this.shuangka[i].iccid}, (res) => {
                                    this.shuangka[i].statusName = res.data.simStatusName;
                                    this.shuangka[i].auth = res.data.simAuthStatus;
                                    this.simAuthStatus = res.data.simAuthStatus;
                                    this.rebind = res.data.rebind;
                                })
                            }
                            this.fetchData('/card/deviceInfo', {iccid: this.iccid}, (res) => {
                                this.deviceInfo = res.data
                            })

                        }

                            if (!this.simAuthStatus) {
                                if(this.operator.activeRule == 2 && !this.totalUsage) {
                                    //先充值再实名

                                }else{
                                    if(!this.showQRcodeModal) {
                                        this.showCopy = true
                                    }
                                    /*if(this.operator.activeRule == 1){//实名后再充值
                                        this.showCopy = true
                                    }else {
                                        this.showCopy = true*/
                                    /*this.$dialog.confirm({
                                        title: '实名提示',
                                        message: '未查询到卡的实名信息，点击确定去实名',
                                    }).then(() => {
                                        // on confirm
                                        this.showCopy = true
                                        //window.location.href = this.operator.authUrl
                                    }).catch(() => {
                                        // on cancel
                                    });*/
                                }


                            }

                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            handleChooseCard(row) {
                this.iccid = row;
                this.cardModal = false;
            },
          changenet(){
              this.currentNet++;
              if(this.currentNet > 2) this.currentNet = 0;
              localStorage.setItem('nettype',this.currentNet)
            this.$dialog.confirm({
              title: '提示',
              message: '确认切换到'+this.netType[this.currentNet]+'？切换成功后请等待5分钟后，重启设备',
            }).then(()=>{
                const time = 5000 + Math.floor(Math.random()*3000)
                this.$toast.loading({message:'切换中',duration:0})
              setTimeout(()=>{
                this.$toast.loading().close();
                this.$toast.success('切换成功，请5分钟后重启设备')
              },time)


            }).catch(res=>{
              console.log('cancel')
            })

          },
            onCopySuccess() {
                this.$toast.success('复制成功')
            },
            onCopyError() {
                this.$toast.fail('复制失败');
            },
            subscribeStatus(){
                this.fetchData('/auth/subscribeStatus',{iccid:this.iccid},res=>{
                    if(res.code && res.url){
                        this.showQRcodeModal = true
                        this.qrcodeurl = res.url
                    }
                })
            },
            changeCard(iccid){
                this.fetchData('/change/getUrl',{iccid:iccid},(res)=>{
                    if(res.code && res.url){
                        window.location.href = res.url
                    }else{
                        this.$router.push({name:'change',query:{iccid:this.iccid}})
                    }
                })
            },
            queryStatus(){
                this.fetchData('/card/statusChange', {iccid: this.iccid}, (res) => {
                    this.$toast.clear()
                    if (res.code) {
                        if(res.data.change == 1){
                            this.change = 1
                            if(this.operator.exchangeSwitch==1){
                                this.$dialog.alert({
                                    title: false,
                                    message: "当前卡已不支持续费，我们将为您补发资费更低的卡",
                                    confirmButtonText: '立即换卡',
                                    showCancelButton:true
                                }).then(() => {
                                    this.changeCard(this.iccid)
                                });
                            }
                        }else if(res.data.change==2 && res.data.id){
                            this.$dialog.alert({
                                title: false,
                                message: "您已申请换卡，点击查看换卡进度",
                                confirmButtonText: '立即查看',
                                showCancelButton:true
                            }).then(() => {
                                this.$router.push({name:'changeInfo',query:{id:res.data.id}})
                            }).catch(()=>{});

                        }
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            queryUserCards() {
                this.fetchData('/card/querylist', {}, (res) => {
                    if (res.code) {
                      this.cardlist = [];
                        for (var i in res.data) {
                            let card = res.data[i];
                            this.cardlist.push({
                                name: card.iccid,
                                value: card.iccid
                            })
                            if (card.default == 1 && !this.iccid) {
                                this.iccid = card.iccid;
                            }
                        }
                    } else {
                        this.$dialog.alert({
                            title: false,
                            message: "检测到您还未绑卡，请先绑卡",
                            confirmButtonText: '去绑卡'
                        }).then(() => {
                            this.$router.push({name: 'bind'})
                        });

                    }
                })
            },
            queryOperatorInfo() {
                this.fetchData('/card/cardOperator', {iccid: this.iccid}, (res) => {
                    if (res.code) {
                        this.operator = res.data
                        if(res.data.iccid) {
                            this.authIccid = res.data.iccid
                        }
                        if(this.operator.exchangeSwitch==1){
                            this.$dialog.alert({
                                title: false,
                                message: this.operator.destroyMsg ?this.operator.destroyMsg : "当前卡已不支持续费，我们将为您补发资费更低的卡",
                                confirmButtonText: this.operator.confirmBtn ?this.operator.confirmBtn:'立即换卡',
                                showCancelButton:true
                            }).then((aa) => {
                                this.changeCard(this.iccid)
                            }).catch(()=>{
                                this.queryCardStatus();
                            });
                        }else{
                            this.queryCardStatus();
                        }
                    }else{
                        this.$toast.fail(res.msg)
                    }
                })
            },
            checkCard(){
              this.$dialog.alert({
                title: "跳转提示",
                message: "即将为您打开设备后台，账号密码都是admin",
                confirmButtonText: '去登录',
                  showCancelButton:true
              }).then(() => {
                  window.location.href = "http://192.168.0.1"
                  window.setTimeout( ()=> {
                      this.$toast('请先正常连接设备之后再进行智能检测')
                  },1500)
              });

            },
            showQRcode(){
                this.showQRcodeModal = true;
            }
        }
    };
</script>
<style>
  .toastWidth180px{
    width: 180px;
  }
</style>
<style lang="scss" scoped>
  .device-box{
    .title{
      border-bottom: 1px solid #666;
      display: flex;
      font-size: .26rem;
      padding-bottom: .2rem;
      span:first-child{
        flex: 1;
        font-size: .26rem;
        text-align: left;
      }
      .wifi-btn {
        span{
          border: 1px solid #0b8ed4;
          border-radius: 4px;
          padding: 2px;
          color: #0b8ed4;
        }
      }
    }
    .wifi-box{
      input{
        border: none;
        height: .8rem;
      }
      .md-button-content{
        width: 3rem;
        height: .8rem;
        text-align: center;
        font-size: .32rem;
        line-height: .8rem;
        background: #0b8ed4;
        color: #fff;
      }
    }
  }
  .change-tips {
    font-size: 13px;
    color: #3f3f3f;
    text-align: left;
    line-height: 20px;
  }

  .md-button {
    display: block;
    height: 1rem;
    line-height: 1rem;
    font-size: 0.36rem;
    font-weight: 500;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
    text-align: center;
    box-sizing: border-box;
    -webkit-appearance: none;
    user-select: none;
    -webkit-tap-highlight-color: transparent;
    border-width: initial;
    border-style: none;
    border-color: initial;
    border-image: initial;
    border-radius: 0.04rem;
    outline: 0px;
    transition: all 0.3s ease 0s;
    overflow: visible;
    position: relative;
  }

  .status-using {
    color: #2f86f6 !important;
  }

  .status-over {
    color: #9f9f9f !important;
  }

  .status-waiting {
    color: #9f9f9f !important;
  }

  .md-button.primary {
    background: #2f86f6;
    color: #fff;
  }

  .md-button.block {
    width: 100%;
  }

  .md-button.inactive {
    opacity: .3;
  }

  .md-button-inner {
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    word-break: break-all;
    word-wrap: break-word;
    white-space: nowrap;
  }

  .query-content {
    background: #fff;
    font-size: .12rem;
    margin: .2rem auto;
    -webkit-box-shadow: 0 0 1px #dedede;
    box-shadow: 0 0 1px #dedede;
    border-radius: .1rem;
  }

  .package-list p span {
    line-height: 2;

    &:first-child {
      float: left;
    }

    &:last-child {
      float: right;
    }
  }

  .query-content .page-title {
    margin: .3rem 0 0 0;
    font-size: .3rem;
    height: .8rem;
    line-height: .8rem;
    border-radius: .2rem .2rem 0 0;
    border-bottom: 1px solid #fafafa;
    color: #888;
    text-align: center;
  }

  .page-content {
    padding-bottom: .1rem;
    min-height: 6rem;
    border-radius: 0 0 .2rem .2rem;
    background: #fff;
  }

  .md-field {
    border: none;
  }

  .package-list {
    margin-top: .1rem;
  }

  .md-input-item-input {
    width: 100%;
    height: 1rem;
    color: rgb(17, 26, 52);
    font-size: 0.32rem;
    font-weight: 500;
    font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB", "Microsoft YaHei", 微软雅黑, Arial, sans-serif;
    line-height: 1;
    box-sizing: border-box;
    -webkit-tap-highlight-color: transparent;
    -webkit-appearance: none;
    border-width: initial;
    border-style: none;
    border-color: initial;
    border-image: initial;
    background: 0px 0px;
    outline: 0px;
  }

  imei-input {
    width: 4.8rem;
    text-align: center !important;
  }

  .md-field-item-content {
    position: relative;
    display: -webkit-box;
    display: -webkit-flex;
    display: flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    justify-content: space-between;
    min-height: .8rem;
    /*padding-top: .3rem;
    padding-bottom: .3rem;*/
    box-sizing: border-box;
    border-bottom: 1px solid #ccc;
  }

  .md-field-item-title {
    text-align: left;
    width: 1.6rem;
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    font-size: .24rem;
  }

  .md-field-item-control {
    text-align: left;
    position: relative;
    -webkit-box-flex: 1;
    -webkit-flex: 1 1 0%;
    flex: 1 1 0%;
    color: #111a34;
    font-size: .28rem;
    font-weight: 500;
    padding: 0;
    margin: 0;
    line-height: 1.15;
    border: none;
    background: none;
    outline: none;
    border: 0;
  }

  .md-field-item-control a {
    margin: 0 .1rem;
    font-size: .26rem;
    color: #3a8ee6;
    white-space: nowrap;
  }

  #copy_phone {
    border: none;
    font-weight: 500;
    width: 100%;
    height: .36rem;
    font-size: .32rem;
    user-select: none;
  }

  #copy_phone:disabled {
    background: none;
  }

  .md-field-item-right {
    position: relative;
    -webkit-flex-shrink: 0;
    flex-shrink: 0;
    margin-left: .12rem;
    display: -webkit-inline-box;
    display: -webkit-inline-flex;
    display: inline-flex;
    -webkit-box-align: center;
    -webkit-align-items: center;
    align-items: center;
    -webkit-box-pack: end;
    -webkit-justify-content: flex-end;
    justify-content: flex-end;
    color: #858b9c;
    font-size: .28rem;
  }


  .card-state {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    padding: .2rem 0 .1rem 0;
  }

  .card-state .flow-item {
    font-size: .36rem;
    text-align: center;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
  }

  .card-state .split {
    border-left: 1px solid #fafafa;
    min-height: .4rem;
  }

  .card-state .flow-item .item-title {
    color: #888;
    font-size: .34rem;
  }

  .md-tab-bar {
    position: relative;
    padding-left: .4rem;
    padding-right: .4rem;
    background-color: #f9fafb;
  }

  .dot-gray {
    position: relative;
  }

  .card-state .flow-item .item-content .state-dot {
    margin-top: .08rem;
  }

  .dot-gray:after {
    content: "";
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    -webkit-box-shadow: 0 0 0.1rem #888 inset;
    box-shadow: inset 0 0 0.1rem #888;
  }

  /*.dot-gray:after {
      width: .12rem;
      height: .12rem;
      background-color: #888;
      border-radius: 50%;
  }*/


  .shuangka-status{
    font-size: .28rem;
    span{
      border: 1px solid #fff;
      padding: 2px;
      border-radius: 4px;
    }
    .success{
      color: #2bdb90;
      border-color: #2bdb90;
    }
    .error{
      color: #ff2c27;
      border-color: #ff2c27;
    }
  }
  .shuangka-btns{
    span,a{
      font-size: .28rem;
      border: 1px solid #0b8ed4;
      padding: 2px;
      border-radius: 4px;
      color: #0b8ed4;
    }
  }

  .root {
    background: #fafafa;
    height: 100%;
    font-size: 0;
    .bottom-tips{
      padding: .45rem .45rem 0;
      background: #fff;
      .title{
        text-align: left;
        font-weight: bold;
        color: #242424;
        font-size: .26rem;
        line-height: 0.48rem;
      }
      li{
        color: #666666;
        line-height: .43rem;
        font-size: .24rem;
        text-align: left;
      }
    }
    .bottom-bts-2{
      margin: .2rem auto;
      display: flex;
      width: 6.9rem;
      justify-content: space-between;
      .btn-item{
        width: 3.3rem;
        height: .52rem;
        line-height: .52rem;
        border-radius: .2rem;
        text-align: center;
        font-size: .26rem;
      }
      :first-child{
        background: #e6e9ef;
        color: #858689;
      }
      :last-child{
        background: #0051fe;
        color: #fff;
      }
    }
    .package-list{
      padding: .3rem;
      width: 6.3rem;
      border-radius: .3rem;
      background: #fff;
      margin: 0 auto;
      .now-package-item{
        .package-bili{
          width: 100%;
          border-radius: .12rem;
          height: .03rem;
          background: #f2f6ff;
          .bar{
            height: .03rem;
            width: 40%;
            border-radius: 0.3rem;
            background: #ffa34b;
          }
        }
        .package-name{
          display: flex;
          line-height:.74rem;
          :first-child{
            flex: 1;
            text-align: left;
            color: #242424;
            font-size: .26rem;
          }
          :last-child{
            flex: 1;
            text-align: right;
            font-size: .24rem;
            color: #ffa34b;
          }
        }
      }
      .now-package-expire{
        margin-top: .3rem;
        width: 100%;
        line-height: .6rem;
        color: #fff;
        font-size: .26rem;
        background: linear-gradient(0, #0354fd, #47cdd6);
        border-radius: .2rem;
        >div{
          width: 5.7rem;
          margin: 0 auto;
          display: flex;
          :first-child{
            width: 4.8rem;
            text-align: left;
          }
          :last-child{
            flex: 1;
            width: .9rem;
            text-align: right;
          }
        }
      }
      .title{
        display: flex;
        :first-child{
          flex: 1;
          text-align: left;
          font-size: .3rem;
          font-weight: bold;
          color: #242424;
        }
        :last-child{
          flex: 1;
          text-align: right;
          color: #0051fe;
          font-size: .24rem;
        }
      }
    }
    .card-info{
      padding: .3rem;
      width: 6.3rem;
      border-radius: .3rem;
      background: #fff;
      margin: -.55rem auto .3rem;
      .iccid-info{
        margin-bottom: .34rem;
        display: flex;
        line-height: .52rem;
        .text-left{
          width: 100%;
          font-size: .3rem;
          font-weight: bold;
          text-align: left;
          .number{
            color: #0051fe;
            text-align: left;
          }
        }
        .change-card{
          width: 1.6rem;
          text-align: center;
          font-size: .24rem;
          color: #fff;
          background: #0051fe;
          border-radius: .12rem;
        }
      }
      .card-status-list{
        display: flex;
        justify-content: space-between;
        .card-status-list-item{
          text-align: center;
          .text-1{
            font-size: .28rem;
            font-weight: bold;
          }
          .text-2{
            font-size: .24rem;
            color: #242424;
          }
          .color-blue{
            color: #0051fe;
          }
        }
      }
    }
    .action-top {
      background: #f2f6ff;
      padding: .08rem 0 .9rem;
      border-bottom-left-radius: .3rem;
      border-bottom-right-radius: .3rem;
      .action-list {
        display: flex;
        margin-top: .24rem;
        justify-content: space-between;
        .action-list-item {
          flex: 1;
          text-align: center;
          display: block;
          img,.icon {
            display: block;
            margin: auto;
            width: .3rem;
            padding: .12rem;
            background: #d1eff6;
            border-radius: .08rem;
          }
          .icon{

          }

          span {
            font-size: .24rem;
            color: #242424;
            text-align: center;
            display: block;
            line-height: .42rem;
          }
        }
      }
    }
  }

</style>



// WEBPACK FOOTER //
// src/pages/home.vue